import { render, staticRenderFns } from "./DokumenKontrakForm.vue?vue&type=template&id=6acf1681"
import script from "./DokumenKontrakForm.vue?vue&type=script&lang=js"
export * from "./DokumenKontrakForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports